/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import property from 'lodash/property';
import { SegmentRule } from '../../defs/SegmentRule.defs';
import { UISegmentRuleObject } from '../../defs/UISegmentRuleObject.defs';
import { createRulesForAPI } from '../CreateRulesForAPI/CreateRulesForAPI';

/**
 * Generate the rulesets for the API.
 * @param {Array<UISegmentRuleObject>} rulesets The rulesets configured in the form.
 * @returns {Array<SegmentRule>} List of rulesets structured for the API.
 */
export const createRulesetsForAPI = (rulesets: Array<UISegmentRuleObject>): Array<SegmentRule> => {
  const arrayOfRulesets: Array<SegmentRule> = [];

  rulesets.forEach((ruleset) => {
    arrayOfRulesets.push({
      type: (property(`type`)(ruleset) as string) || `default`,
      [ruleset.operator]: createRulesForAPI(ruleset.rules),
    });
  });

  return arrayOfRulesets;
};
